export default {
    getFormattedDate(dateString) {
        let date = new Date(dateString);
        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');

        return day + '/' + month + '/' + year;
    },
    formatDate(date) {
        const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
        return newDate.toISOString().slice(0, 10);
    },
    formatTime(date) {
        return date.toLocaleTimeString('en-US');
    },
    formatDateTime(date) {
        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');

        // Combine the formatted date and time with a space in between
        return day + '-' + month + '-' + year + ' ' + this.formatTime(date);
    },
    getISOString(date) {
        let d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = '' + d.getFullYear(),
                hours = '' + d.getHours(),
                minutes = '' + d.getMinutes(),
                seconds = '' + d.getSeconds();
        month = month.length < 2 ? '0' + month : month;
        day = day.length < 2 ? '0' + day : day;
        hours = hours.length < 2 ? '0' + hours : hours;
        minutes = minutes.length < 2 ? '0' + minutes : minutes;
        seconds = seconds.length < 2 ? '0' + seconds : seconds;
        return ([year, month, day].join('-') + 'T' + [hours, minutes, seconds].join(':') + '.000');
    }
}